import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "px-6 flex flex-col gap-5" }
const _hoisted_2 = { class: "text-3xl font-black dark:text-white" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col w-full bg-white shadow-base px-10 py-10 rounded-3xl"
}
const _hoisted_4 = { class: "flex flex-col gap-5" }
const _hoisted_5 = { class: "w-full space-y-3" }
const _hoisted_6 = { class: "text-xl font-bold text-left" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col gap-8 w-full pt-3"
}
const _hoisted_10 = { class: "flex justify-end gap-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, " Cancel ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, " Save ", -1)

import { ref } from "vue"
  import { useCultureKitStore } from "@/store/cultureKit"
  import { useRoute } from "vue-router"
  import jwt from "@/utils/jwt"
  import { toastController } from "@ionic/vue"

  // components
  import WbButton from "@/components/template/buttonTemplate.vue"
  import WbTextArea from "@/components/template/TextAreaTemplate.vue"

  // initializations
  
export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionContainer',
  setup(__props) {

  const store = useCultureKitStore()
  const nbf = jwt.generateNBF()
  const route = useRoute()
  const edit = ref<number | null>(null)

  /**
   * replace &nbsp; with whitespace
   */
  const replacenbsp = (val: string) => val.replaceAll("&nbsp;", " ")

  /**
   * toggles answer/edit
   * @param index answer index
   */
  const toggleEdit = (index: number) => {
    edit.value = edit.value === index ? null : index
  }

  /**
   * on cancel event
   * @param index answer index
   */
  const onCancel = async (index: number) => {
    if (store.answer_id.length) {
      await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    } else store.answers[index].answer = ""
    toggleEdit(index)
  }

  /**
   * on save event
   * @param index answer index
   */
  const onSave = async (index: number) => {
    let statusMessage = ""
    if (store.answer_id.length) {
      store.status = store.initial_answers.status
      statusMessage = await store.updateAnswer(nbf, route.query.token as string, "ambassadorship")
    } else {
      store.status = "draft"
      statusMessage = await store.saveAnswer(nbf, route.query.token as string, "ambassadorship")
    }
    statusMessage = await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    toggleEdit(index)

    if (statusMessage !== "" && statusMessage !== undefined) {
      const toast = await toastController.create({
        message: statusMessage,
        duration: 1500,
        position: "top",
        color: "success",
      })

      await toast.present()
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).labels, (label) => {
      return (_openBlock(), _createElementBlock("div", {
        key: label,
        class: "space-y-5 pb-10"
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(label), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).answers, (group, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: group.question,
            class: ""
          }, [
            (group.topic === label)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(group.question), 1),
                      (edit.value !== index)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            innerHTML: replacenbsp(group.answer)
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (edit.value !== index && _unref(store).status === 'draft')
                        ? (_openBlock(), _createBlock(WbButton, {
                            key: 0,
                            class: "h-11",
                            type: group.answer.length ? 'default' : 'primary',
                            onClick: ($event: any) => (toggleEdit(index))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("strong", null, _toDisplayString(group.answer.length ? "Edit" : "Answer"), 1)
                            ]),
                            _: 2
                          }, 1032, ["type", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (edit.value === index)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(WbTextArea, {
                          modelValue: group.answer,
                          "onUpdate:modelValue": ($event: any) => ((group.answer) = $event),
                          name: "question",
                          "hide-toolbar": true,
                          placeholder: "Share your thoughts..."
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(WbButton, {
                            class: "h-11 w-full",
                            type: "default",
                            "native-type": "button",
                            onClick: ($event: any) => (onCancel(index))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(WbButton, {
                            class: "h-11 w-full",
                            type: "primary",
                            "native-type": "button",
                            onClick: ($event: any) => (onSave(index))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})